import { render, staticRenderFns } from "./message-view.vue?vue&type=template&id=7e2133c2&scoped=true&"
import script from "./message-view.vue?vue&type=script&lang=js&"
export * from "./message-view.vue?vue&type=script&lang=js&"
import style0 from "./message-view.vue?vue&type=style&index=0&id=7e2133c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2133c2",
  null
  
)

export default component.exports